import { normalize } from 'normalizr';

import {
  fastenerBomItemSchema,
  unresolvedFastenerBomItemSchema,
} from './entities';

export const types = {
  FASTENER_BOM_ADD_ITEM_REQUEST:
    'partLibrary/viewer/penn/FASTENER_BOM_ADD_ITEM_REQUEST',
  FASTENER_BOM_ADD_ITEM_SUCCESS:
    'partLibrary/viewer/penn/FASTENER_BOM_ADD_ITEM_SUCCESS',
  FASTENER_BOM_REMOVE_ITEM: 'partLibrary/viewer/penn/FASTENER_BOM_REMOVE_ITEM',
  FASTENER_BOM_SET: 'partLibrary/viewer/penn/FASTENER_BOM_SET',
  UNRESOLVED_FASTENER_BOM_SET:
    'partLibrary/viewer/penn/UNRESOLVED_FASTENER_BOM_SET',
  FETCH_AVAILABLE_DISTRIBUTORS_ERROR:
    'partLibrary/viewer/penn/FETCH_AVAILABLE_DISTRIBUTORS_ERROR',
  FETCH_AVAILABLE_DISTRIBUTORS_REQUEST:
    'partLibrary/viewer/penn/FETCH_AVAILABLE_DISTRIBUTORS_REQUEST',
  FETCH_AVAILABLE_DISTRIBUTORS_SUCCESS:
    'partLibrary/viewer/penn/FETCH_AVAILABLE_DISTRIBUTORS_SUCCESS',

  MAKE_QUANTITIES_SELECT: 'partLibrary/viewer/penn/MAKE_QUANTITIES_SELECT',
  MAKE_QUANTITIES_UPDATE: 'partLibrary/viewer/penn/MAKE_QUANTITIES_UPDATE',
  SELECTED_BOM_ITEM_SET: 'partLibrary/viewer/penn/SELECTED_BOM_ITEM_SET',
  SELECTED_DISTRIBUTORS_ADD:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_ADD',
  SELECTED_DISTRIBUTORS_REMOVE:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_REMOVE',
  SELECTED_DISTRIBUTORS_SET:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_SET',
  SELECTED_DISTRIBUTORS_SET_INITIAL:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_SET_INITIAL',
  SELECTED_DISTRIBUTORS_ADD_DETAIL:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_ADD_DETAIL',
  SELECTED_DISTRIBUTORS_REMOVE_DETAIL:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_REMOVE_DETAIL',
  SELECTED_DISTRIBUTORS_ADD_DETAIL_BULK:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_ADD_DETAIL_BULK',
  SELECTED_DISTRIBUTORS_ADD_BOM_DRAWER:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_ADD_BOM_DRAWER',
  SELECTED_DISTRIBUTORS_REMOVE_BOM_DRAWER:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_REMOVE_BOM_DRAWER',
  SELECTED_DISTRIBUTORS_ADD_BULK_BOM_DRAWER:
    'partLibrary/viewer/penn/SELECTED_DISTRIBUTORS_ADD_BULK_BOM_DRAWER',

  RESOLVE_MATCH_REQUEST: 'partLibrary/viewer/penn/RESOLVE_MATCH_REQUEST',
  RESOLVE_MATCH_SUCCESS: 'partLibrary/viewer/penn/RESOLVE_MATCH_SUCCESS',
  RESOLVE_MATCH_CANCEL: 'partLibrary/viewer/penn/RESOLVE_MATCH_CANCEL',
};

export const fetchAvailableDistributors = {
  error: () => ({
    type: types.FETCH_AVAILABLE_DISTRIBUTORS_ERROR,
  }),
  request: () => ({
    type: types.FETCH_AVAILABLE_DISTRIBUTORS_REQUEST,
  }),
  success: ({ distributors }) => ({
    type: types.FETCH_AVAILABLE_DISTRIBUTORS_SUCCESS,
    payload: { distributors },
  }),
};

export const selectedDistributors = {
  add: ({ distributorId }) => ({
    type: types.SELECTED_DISTRIBUTORS_ADD,
    payload: { distributorId },
  }),
  remove: ({ distributorId }) => ({
    type: types.SELECTED_DISTRIBUTORS_REMOVE,
    payload: { distributorId },
  }),
  set: ({ distributorId }) => ({
    type: types.SELECTED_DISTRIBUTORS_SET,
    payload: { distributorId },
  }),
  setInitial: ({ distributorId }) => ({
    type: types.SELECTED_DISTRIBUTORS_SET_INITIAL,
    payload: { distributorId },
  }),
};

export const selectedDistributorsDetailsView = {
  add: ({ distributorId }) => ({
    type: types.SELECTED_DISTRIBUTORS_ADD_DETAIL,
    payload: { distributorId },
  }),
  remove: ({ distributorId }) => ({
    type: types.SELECTED_DISTRIBUTORS_REMOVE_DETAIL,
    payload: { distributorId },
  }),
  addBulk: ({ distributorIds }) => ({
    type: types.SELECTED_DISTRIBUTORS_ADD_DETAIL_BULK,
    payload: { distributorIds },
  }),
};

export const selectedDistributorsBomView = {
  add: ({ distributorId }) => ({
    type: types.SELECTED_DISTRIBUTORS_ADD_BOM_DRAWER,
    payload: { distributorId },
  }),
  remove: ({ distributorId }) => ({
    type: types.SELECTED_DISTRIBUTORS_REMOVE_BOM_DRAWER,
    payload: { distributorId },
  }),
  addBulk: ({ distributorIds }) => ({
    type: types.SELECTED_DISTRIBUTORS_ADD_BULK_BOM_DRAWER,
    payload: { distributorIds },
  }),
};

export const fastenerAvailability = {
  makeQuantitiesSelect: ({ index }) => ({
    type: types.MAKE_QUANTITIES_SELECT,
    payload: { index },
  }),
  makeQuantitiesUpdate: ({ makeQuantities }) => ({
    type: types.MAKE_QUANTITIES_UPDATE,
    payload: { makeQuantities },
  }),
};

export const fastenerBom = {
  addItemRequest: ({ bomItem }) => ({
    type: types.FASTENER_BOM_ADD_ITEM_REQUEST,
    payload: { bomItem },
  }),
  addItemSuccess: ({ bomItem }) => ({
    type: types.FASTENER_BOM_ADD_ITEM_SUCCESS,
    payload: normalize(bomItem, fastenerBomItemSchema),
  }),
  removeItem: ({ productId }) => ({
    type: types.FASTENER_BOM_REMOVE_ITEM,
    payload: {
      productId,
    },
  }),
  set: ({ bom }) => ({
    type: types.FASTENER_BOM_SET,
    payload: normalize(bom, [fastenerBomItemSchema]),
  }),
};

export const unresolvedFastenerBom = {
  set: ({ bom }) => ({
    type: types.UNRESOLVED_FASTENER_BOM_SET,
    payload: normalize(bom, [unresolvedFastenerBomItemSchema]),
  }),
};

export const selectedBomItem = {
  set: ({ productId }) => ({
    type: types.SELECTED_BOM_ITEM_SET,
    payload: {
      productId,
    },
  }),
};

export const resolveMatch = {
  request: ({ partUuid }) => ({
    type: types.RESOLVE_MATCH_REQUEST,
    payload: {
      partUuid,
    },
  }),
  success: ({ product }) => ({
    type: types.RESOLVE_MATCH_SUCCESS,
    payload: {
      product,
    },
  }),
  cancel: () => ({
    type: types.RESOLVE_MATCH_CANCEL,
  }),
};
